(() => {
  let cleanup;
  const mount = () => {
    cleanup?.();
    const root = document.querySelector('product-info[id^="MainProduct"]');
    if (!root) return;
    const nativeButton = () => root.querySelector('product-form .product-form__submit');
    if (!nativeButton()) return;
    const bar = document.createElement('aside');
    bar.className = 'iron-mobile-buy';
    const info = document.createElement('div');
    const variant = document.createElement('span');
    const price = document.createElement('strong');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'iron-mobile-buy__button';
    info.className = 'iron-mobile-buy__info';
    info.append(variant, price);
    bar.append(info, button);
    document.body.append(bar);
    document.body.classList.add('iron-has-mobile-buy');
    const sync = () => {
      const original = nativeButton();
      const priceRoot = root.querySelector('[id^="price-"]');
      const sale = priceRoot?.querySelector('.price--on-sale');
      const amount = sale?.querySelector('.price-item--sale') || priceRoot?.querySelector('.price__regular .price-item--regular');
      const options = [...root.querySelectorAll('variant-selects input:checked, variant-selects select option:checked')].map(el => el.value);
      variant.textContent = options.join(' / ') || root.querySelector('h1')?.textContent.trim() || '';
      price.textContent = priceRoot?.classList.contains('hidden') ? '' : amount?.textContent.trim() || '';
      button.textContent = original?.querySelector('span')?.textContent.trim() || window.variantStrings.unavailable;
      button.disabled = !original || original.disabled || original.getAttribute('aria-disabled') === 'true';
      bar.setAttribute('aria-label', root.querySelector('h1')?.textContent.trim() || 'IronForce');
    };
    let frame;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','value']});
    root.addEventListener('change', schedule);
    button.addEventListener('click', () => {
      const original = nativeButton();
      if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
      original.click();
      sync();
      const error = root.querySelector('.product-form__error-message-wrapper');
      if (error && !error.hasAttribute('hidden')) error.scrollIntoView({block:'center'});
    });
    sync();
    cleanup = () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      root.removeEventListener('change', schedule);
      bar.remove();
      document.body.classList.remove('iron-has-mobile-buy');
    };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('product-info:loaded', mount);
})();
